import React, { useState, useEffect} from 'react';
import {
    Table, Button, Space, Input, Form, message, Typography, Tag, Select,
    Modal, Upload, Drawer, Empty, Divider, Popconfirm
} from 'antd';
import {
    PlusOutlined, SearchOutlined, UploadOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;
const { Option } = Select;

// ============================================================
// Mock 数据 — TODO: 联调时替换为接口
// ============================================================
const INIT_ALGORITHMS = [
    { id: 1, AIIoTType: '1000', AIIoTName: '人形/运动检测', algorithmType: 1, descr: '检测画面中的人形和运动物体', icon: '', capabilityCount: 3, eventCount: 2, serviceIDs: ['300026', '300027'] },
    { id: 2, AIIoTType: '1004', AIIoTName: '声音检测', algorithmType: 1, descr: '检测异常声音（哭声、玻璃破碎等）', icon: '', capabilityCount: 2, eventCount: 3, serviceIDs: ['300039'] },
    { id: 9, AIIoTType: '1011', AIIoTName: '云端抓图', algorithmType: 1, descr: '设备端云端抓图配置', icon: '', capabilityCount: 0, eventCount: 0, serviceIDs: [] },
    { id: 3, AIIoTType: '1010', AIIoTName: '云端录像', algorithmType: 2, descr: '事件触发云端录像存储', icon: '', capabilityCount: 0, eventCount: 1, serviceIDs: ['300028'] },
    { id: 4, AIIoTType: '1028', AIIoTName: '区域闯入检测', algorithmType: 1, descr: '检测物体进入指定区域', icon: '', capabilityCount: 2, eventCount: 2, serviceIDs: ['300032'] },
    { id: 5, AIIoTType: '1034', AIIoTName: '车辆检测', algorithmType: 1, descr: '检测画面中的车辆', icon: '', capabilityCount: 1, eventCount: 1, serviceIDs: ['300044'] },
    { id: 6, AIIoTType: '1063', AIIoTName: '语音助手', algorithmType: 2, descr: '设备端语音交互与指令识别', icon: '', capabilityCount: 0, eventCount: 0, serviceIDs: ['300050'] },
    { id: 7, AIIoTType: '1096', AIIoTName: '儿童检测', algorithmType: 1, descr: '检测画面中的儿童并告警', icon: '', capabilityCount: 1, eventCount: 2, serviceIDs: ['300022'] },
    { id: 8, AIIoTType: '1106', AIIoTName: '烟雾/火焰检测', algorithmType: 1, descr: '检测画面中的烟雾和火焰', icon: '', capabilityCount: 1, eventCount: 1, serviceIDs: ['300031'] },
];

const MOCK_SERVICES = [
    { id: 1, serviceId: '300021', serviceName: '移动侦测服务', descr: '基础移动侦测' },
    { id: 2, serviceId: '300022', serviceName: '儿童检测服务', descr: '儿童活动区域检测' },
    { id: 3, serviceId: '300026', serviceName: '人形检测服务', descr: '端侧人形识别' },
    { id: 4, serviceId: '300027', serviceName: '运动检测服务', descr: '运动物体追踪' },
    { id: 5, serviceId: '300028', serviceName: '云端录像服务', descr: '全天候云存储' },
    { id: 6, serviceId: '300029', serviceName: '事件云存服务', descr: '事件触发录像' },
    { id: 7, serviceId: '300031', serviceName: '烟雾检测服务', descr: '火灾预警' },
    { id: 8, serviceId: '300032', serviceName: '区域闯入服务', descr: '虚拟围栏' },
    { id: 9, serviceId: '300039', serviceName: '声音检测服务', descr: '异常声音识别' },
    { id: 10, serviceId: '300044', serviceName: '车辆检测服务', descr: '车辆识别' },
    { id: 11, serviceId: '300050', serviceName: '语音助手服务', descr: '语音交互' },
];

const MOCK_EVENTS = [
    { id: 1, eventId: '10001', eventName: '移动侦测告警' },
    { id: 2, eventId: '10002', eventName: '人形检测告警' },
    { id: 3, eventId: '10003', eventName: '声音异常告警' },
    { id: 4, eventId: '10004', eventName: '宠物检测告警' },
    { id: 5, eventId: '10005', eventName: '门铃呼叫' },
    { id: 6, eventId: '10006', eventName: '烟雾告警' },
    { id: 7, eventId: '10007', eventName: '温度异常告警' },
    { id: 8, eventId: '10008', eventName: '车辆检测告警' },
];

// ============================================================
// 主组件
// ============================================================
const AlgorithmLibrary = () => {
    const navigate = useNavigate();

    // ---- 列表 ----
    const [algorithms, setAlgorithms] = useState(INIT_ALGORITHMS);
    const [loading, setLoading] = useState(false);
    const [searchForm, setSearchForm] = useState({ keyword: '', algorithmType: 0 });
    const [pagin, setPagin] = useState({ page: 1, pageSize: 20, total: 0 });

    // ---- 算法 Dialog ----
    const [dlgVisible, setDlgVisible] = useState(false);
    const [dlgMode, setDlgMode] = useState('add');
    const [dlgData, setDlgData] = useState(null);
    const [dlgLoading, setDlgLoading] = useState(false);
    const [algoForm] = Form.useForm();
    const [iconUrl, setIconUrl] = useState('');

    // ---- 服务绑定 Drawer ----
    const [svcDrawer, setSvcDrawer] = useState(false);
    const [svcAiiotType, setSvcAiiotType] = useState(null);
    const [svcSelected, setSvcSelected] = useState([]);

    // ---- 事件绑定 Drawer ----
    const [evtDrawer, setEvtDrawer] = useState(false);
    const [evtAiiotType, setEvtAiiotType] = useState(null);
    const [evtSelected, setEvtSelected] = useState([]);

    // ============================================================
    // 列表加载
    // ============================================================
    const loadList = async (page = 1, pageSize = 20) => {
        setLoading(true);
        // TODO: 联调时替换为 pageAlgorithm API
        await new Promise(r => setTimeout(r, 200));
        let filtered = algorithms;
        if (searchForm.keyword) {
            const kw = searchForm.keyword.toLowerCase();
            filtered = filtered.filter(a =>
                String(a.AIIoTType).includes(kw) || (a.AIIoTName || '').toLowerCase().includes(kw)
            );
        }
        if (searchForm.algorithmType > 0) {
            filtered = filtered.filter(a => a.algorithmType === searchForm.algorithmType);
        }
        setPagin({ page, pageSize, total: filtered.length });
        setLoading(false);
    };

    useEffect(() => { loadList(); }, []); // eslint-disable-line

    const getPageData = () => {
        const start = (pagin.page - 1) * pagin.pageSize;
        return algorithms
            .filter(a => {
                if (searchForm.keyword) {
                    const kw = searchForm.keyword.toLowerCase();
                    if (!String(a.AIIoTType).includes(kw) && !(a.AIIoTName || '').toLowerCase().includes(kw)) return false;
                }
                if (searchForm.algorithmType > 0 && a.algorithmType !== searchForm.algorithmType) return false;
                return true;
            })
            .slice(start, start + pagin.pageSize);
    };

    const handleSearch = () => { setPagin(p => ({ ...p, page: 1 })); loadList(1, pagin.pageSize); };
    const handleReset = () => { setSearchForm({ keyword: '', algorithmType: 0 }); setPagin(p => ({ ...p, page: 1 })); };

    const isImageUrl = (icon) => icon && (/^https?:\/\//.test(icon) || /\.(png|jpe?g|gif|svg|webp)$/i.test(icon));

    // ============================================================
    // 算法 CRUD
    // ============================================================
    const handleAdd = () => {
        setDlgMode('add');
        setDlgData(null);
        setIconUrl('');
        algoForm.resetFields();
        algoForm.setFieldsValue({ algorithmType: 1 });
        setDlgVisible(true);
    };

    const handleEdit = (row) => {
        setDlgMode('edit');
        setDlgData(row);
        setIconUrl(row.icon || '');
        setDlgLoading(true);
        // TODO: 联调时替换为 getAlgorithmDetail API
        setTimeout(() => {
            algoForm.setFieldsValue({
                AIIoTType: row.AIIoTType,
                AIIoTName: row.AIIoTName,
                algorithmType: row.algorithmType,
                descr: row.descr || '',
            });
            setDlgLoading(false);
        }, 150);
        setDlgVisible(true);
    };

    const handleAlgoSubmit = async () => {
        try {
            const values = await algoForm.validateFields();
            setDlgLoading(true);
            // TODO: 联调时替换为 addAlgorithm / updateAlgorithm API
            await new Promise(r => setTimeout(r, 300));
            if (dlgMode === 'add') {
                const newAlgo = {
                    id: Math.max(...algorithms.map(a => a.id), 0) + 1,
                    AIIoTType: String(values.AIIoTType),
                    AIIoTName: values.AIIoTName,
                    algorithmType: values.algorithmType,
                    descr: values.descr || '',
                    icon: iconUrl,
                    capabilityCount: 0,
                    eventCount: 0,
                    serviceIDs: [],
                };
                setAlgorithms(prev => [...prev, newAlgo]);
                message.success('创建成功');
            } else {
                setAlgorithms(prev => prev.map(a =>
                    a.id === dlgData.id
                        ? { ...a, AIIoTName: values.AIIoTName, algorithmType: values.algorithmType, descr: values.descr || '', icon: iconUrl }
                        : a
                ));
                message.success('保存成功');
            }
            setDlgVisible(false);
            loadList(pagin.page, pagin.pageSize);
        } catch { /* 校验失败 */ } finally {
            setDlgLoading(false);
        }
    };

    const handleDelete = (row) => {
        // TODO: 联调时替换为 deleteAlgorithm API
        const idx = algorithms.findIndex(a => a.id === row.id);
        if (idx >= 0) {
            setAlgorithms(prev => prev.filter(a => a.id !== row.id));
            message.success('已删除');
        }
    };

    // ============================================================
    // 服务绑定
    // ============================================================
    const openServiceBind = (row) => {
        setSvcAiiotType(row.AIIoTType);
        setSvcSelected((row.serviceIDs || []).map(s => String(s)));
        setSvcDrawer(true);
    };

    const handleServiceSave = () => {
        // TODO: 联调时替换为 bindAlgorithmServices API
        setAlgorithms(prev => prev.map(a =>
            String(a.AIIoTType) === String(svcAiiotType)
                ? { ...a, serviceIDs: svcSelected }
                : a
        ));
        message.success('关联服务保存成功');
        setSvcDrawer(false);
    };

    // ============================================================
    // 事件绑定
    // ============================================================
    const openEventBind = (row) => {
        setEvtAiiotType(row.AIIoTType);
        // 模拟已绑定事件（从现有 eventCount 反向推断）
        const mockBound = row.eventCount > 0
            ? MOCK_EVENTS.slice(0, row.eventCount).map(e => e.eventId)
            : [];
        setEvtSelected(mockBound);
        setEvtDrawer(true);
    };

    const handleEventSave = () => {
        // TODO: 联调时替换为 bindAlgorithmEvents API
        setAlgorithms(prev => prev.map(a =>
            String(a.AIIoTType) === String(evtAiiotType)
                ? { ...a, eventCount: evtSelected.length }
                : a
        ));
        message.success('关联事件保存成功');
        setEvtDrawer(false);
    };

    // ============================================================
    // 表格列（对齐 Real 项目 AlgorithmTab）
    // ============================================================
    const tableData = getPageData();
    const isEmpty = !loading && tableData.length === 0;
    const hasFilter = searchForm.keyword || searchForm.algorithmType > 0;

    const columns = [
        {
            title: '算法ID（AIIOTTYPE）', dataIndex: 'AIIoTType', width: 180,
            render: t => <Tag color="processing" style={{ fontFamily: 'Menlo,Monaco,monospace', fontWeight: 500 }}>{t}</Tag>,
        },
        {
            title: '图标', dataIndex: 'icon', width: 70, align: 'center',
            render: icon => icon && isImageUrl(icon)
                ? <img src={icon} alt="" style={{ width: 28, height: 28, objectFit: 'contain', borderRadius: 4 }} />
                : <span style={{ fontSize: 18 }}>📦</span>,
        },
        {
            title: '算法名称', dataIndex: 'AIIoTName', width: 160,
            render: t => <Text strong style={{ color: '#303133' }}>{t || '—'}</Text>,
        },
        {
            title: '算法类型', dataIndex: 'algorithmType', width: 80, align: 'center',
            render: t => <Tag color={t === 2 ? 'orange' : 'default'}>{t === 2 ? '平台' : '设备端'}</Tag>,
        },
        {
            title: '描述', dataIndex: 'descr', width: 180, ellipsis: { showTitle: false },
            render: t => <Text type="secondary" style={{ fontSize: 13 }}>{t || '—'}</Text>,
        },
        {
            title: '关联能力', dataIndex: 'capabilityCount', width: 100, align: 'center',
            render: (count, record) => (
                <Button type="link" size="small" onClick={() => navigate(`/model/algorithm/capability/${record.AIIoTType}`)}>
                    {count || 0}
                </Button>
            ),
        },
        {
            title: '关联事件', dataIndex: 'eventCount', width: 100, align: 'center',
            render: (count, record) => count > 0
                ? <Tag color="success" style={{ cursor: 'pointer' }} onClick={() => openEventBind(record)}>{count}</Tag>
                : <Button type="link" size="small" onClick={() => openEventBind(record)}>配置</Button>,
        },
        {
            title: '关联服务', dataIndex: 'serviceIDs', width: 100, align: 'center',
            render: (ids, record) => (ids && ids.length > 0)
                ? <Text type="primary" underline style={{ cursor: 'pointer' }} onClick={() => openServiceBind(record)}>{ids.length}</Text>
                : <Button type="link" size="small" onClick={() => openServiceBind(record)}>配置</Button>,
        },
        {
            title: '操作', width: 130, align: 'center',
            render: (_, record) => (
                <Space size={0} split={<Divider type="vertical" />}>
                    <Button type="link" size="small" onClick={() => handleEdit(record)}>编辑</Button>
                    <Popconfirm
                        title="删除确认"
                        description={`确认删除算法「${record.AIIoTName || record.AIIoTType}」？\n\n删除后将同时清除该算法与所有服务、事件的关联关系。`}
                        icon={<ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />}
                        onConfirm={() => handleDelete(record)}
                        okText="确认删除"
                        okButtonProps={{ danger: true }}
                        cancelText="取消"
                    >
                        <Button type="link" size="small" danger>删除</Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    // ============================================================
    // 渲染
    // ============================================================
    return (
        <div style={{ padding: '20px 20px 0', background: '#fff', minHeight: '100%' }}>
            {/* ---- 搜索栏 ---- */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                <Space size={10}>
                    <Input
                        prefix={<SearchOutlined />}
                        placeholder="搜索 AIIoTType / 名称"
                        value={searchForm.keyword}
                        onChange={e => setSearchForm(p => ({ ...p, keyword: e.target.value }))}
                        onPressEnter={handleSearch}
                        style={{ width: 240 }}
                        allowClear
                    />
                    <Select
                        value={searchForm.algorithmType}
                        onChange={v => setSearchForm(p => ({ ...p, algorithmType: v }))}
                        placeholder="算法类型"
                        style={{ width: 140 }}
                        allowClear
                        onClear={() => setSearchForm(p => ({ ...p, algorithmType: 0 }))}
                    >
                        <Option value={0}>全部</Option>
                        <Option value={1}>设备端</Option>
                        <Option value={2}>平台</Option>
                    </Select>
                    <Button type="primary" onClick={handleSearch}>查询</Button>
                    <Button onClick={handleReset}>重置</Button>
                </Space>
                <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>添加算法</Button>
            </div>

            {/* ---- 表格 ---- */}
            {!isEmpty && (
                <Table
                    columns={columns}
                    dataSource={tableData}
                    rowKey="id"
                    loading={loading}
                    size="small"
                    pagination={{
                        current: pagin.page,
                        pageSize: pagin.pageSize,
                        total: pagin.total,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50'],
                        showTotal: t => `共 ${t} 条`,
                        onChange: (p, ps) => { setPagin(prev => ({ ...prev, page: p, pageSize: ps })); },
                    }}
                    scroll={{ x: 1200 }}
                />
            )}

            {/* ---- 空状态 ---- */}
            {isEmpty && (
                <Empty
                    description={hasFilter ? '未找到匹配的算法' : '暂无算法数据'}
                    style={{ padding: '60px 0' }}
                >
                    {!hasFilter && <Button type="primary" onClick={handleAdd}>添加算法</Button>}
                </Empty>
            )}

            {/* ═══════════════════════════════════════ */}
            {/* 算法 Dialog（对齐 Real AlgorithmDialog） */}
            {/* ═══════════════════════════════════════ */}
            <Modal
                title={dlgMode === 'add' ? '添加算法' : '编辑算法'}
                open={dlgVisible}
                onOk={handleAlgoSubmit}
                onCancel={() => setDlgVisible(false)}
                confirmLoading={dlgLoading}
                okText={dlgMode === 'add' ? '确认创建' : '确认保存'}
                cancelText="取消"
                width={520}
                destroyOnClose
                maskClosable={false}
            >
                <Form form={algoForm} layout="horizontal" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <Form.Item name="AIIoTType" label="算法ID" rules={[{ required: true, message: '请输入 AlgorithmID' }]}>
                        <Input placeholder="如 4001" disabled={dlgMode === 'edit'} />
                    </Form.Item>
                    <Form.Item name="AIIoTName" label="算法名称" rules={[{ required: true, message: '请输入算法名称' }]}>
                        <Input placeholder="请输入算法名称" />
                    </Form.Item>
                    <Form.Item name="algorithmType" label="算法类型">
                        <Select style={{ width: '100%' }}>
                            <Option value={1}>设备端</Option>
                            <Option value={2}>平台</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="descr" label="描述">
                        <Input.TextArea rows={3} maxLength={512} showCount placeholder="请输入描述" />
                    </Form.Item>
                    <Form.Item label="图标">
                        <Upload
                            listType="picture-card"
                            maxCount={1}
                            showUploadList={false}
                            beforeUpload={file => {
                                const isImage = file.type.startsWith('image/');
                                if (!isImage) { message.error('请上传图片文件'); return false; }
                                if (file.size / 1024 / 1024 > 2) { message.error('图片大小不能超过2MB'); return false; }
                                const reader = new FileReader();
                                reader.onload = e => setIconUrl(e.target.result);
                                reader.readAsDataURL(file);
                                return false;
                            }}
                            accept="image/*"
                        >
                            {iconUrl ? (
                                <img src={iconUrl} alt="" style={{ width: 48, height: 48, objectFit: 'contain', borderRadius: 6 }} />
                            ) : (
                                <div><UploadOutlined /><div style={{ marginTop: 8 }}>上传图标</div></div>
                            )}
                        </Upload>
                        {iconUrl && (
                            <Button type="link" danger size="small" style={{ marginLeft: 8 }} onClick={() => setIconUrl('')}>
                                移除
                            </Button>
                        )}
                    </Form.Item>
                </Form>
            </Modal>

            {/* ═══════════════════════════════════════ */}
            {/* 关联服务 Drawer（对齐 Real ServiceBindDrawer） */}
            {/* ═══════════════════════════════════════ */}
            <Drawer
                title={`关联服务 — 算法 ${svcAiiotType || ''}`}
                open={svcDrawer}
                onClose={() => setSvcDrawer(false)}
                width={560}
                destroyOnClose
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, paddingTop: 12 }}>
                        <Button onClick={() => setSvcDrawer(false)}>取消</Button>
                        <Button type="primary" onClick={handleServiceSave}>确认</Button>
                    </div>
                }
            >
                <Table
                    rowKey="serviceId"
                    dataSource={MOCK_SERVICES}
                    size="small"
                    rowSelection={{
                        type: 'checkbox',
                        selectedRowKeys: svcSelected,
                        onChange: keys => setSvcSelected(keys),
                    }}
                    columns={[
                        { title: '服务ID', dataIndex: 'serviceId', width: 120 },
                        { title: '服务名称', dataIndex: 'serviceName', width: 140, render: t => <Text strong>{t}</Text> },
                        { title: '描述', dataIndex: 'descr', ellipsis: true, render: t => <Text type="secondary" style={{ fontSize: 13 }}>{t || '—'}</Text> },
                    ]}
                    pagination={false}
                />
            </Drawer>

            {/* ═══════════════════════════════════════ */}
            {/* 关联事件 Drawer（对齐 Real EventBindDrawer） */}
            {/* ═══════════════════════════════════════ */}
            <Drawer
                title={`关联事件 — 算法 ${evtAiiotType || ''}`}
                open={evtDrawer}
                onClose={() => setEvtDrawer(false)}
                width={500}
                destroyOnClose
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, paddingTop: 12 }}>
                        <Button onClick={() => setEvtDrawer(false)}>取消</Button>
                        <Button type="primary" onClick={handleEventSave}>确认</Button>
                    </div>
                }
            >
                <Table
                    rowKey="eventId"
                    dataSource={MOCK_EVENTS}
                    size="small"
                    rowSelection={{
                        type: 'checkbox',
                        selectedRowKeys: evtSelected,
                        onChange: keys => setEvtSelected(keys),
                    }}
                    columns={[
                        { title: '事件ID', dataIndex: 'eventId', width: 110 },
                        { title: '事件名称', dataIndex: 'eventName', width: 160, render: t => <Text strong>{t}</Text> },
                    ]}
                    pagination={false}
                />
            </Drawer>
        </div>
    );
};

export default AlgorithmLibrary;
